var pad = function pad(n) {
  return n < 10 ? "0".concat(n) : n;
};
export var isInvalidInput = function isInvalidInput(seconds) {
  return isNaN(seconds) || seconds === Infinity || seconds < 0;
};
export var secondsToTime = function secondsToTime(seconds) {
  if (isInvalidInput(seconds)) {
    return {
      seconds: 0,
      minutes: 0,
      hours: 0
    };
  }
  var totalSeconds = parseInt("".concat(seconds), 10);
  var hours = Math.floor(totalSeconds / 3600);
  var remainingSeconds = totalSeconds % 3600;
  var minutes = Math.floor(remainingSeconds / 60);
  remainingSeconds %= 60;
  return {
    seconds: remainingSeconds,
    minutes: minutes,
    hours: hours
  };
};
export var formatDuration = function formatDuration(seconds) {
  if (isInvalidInput(seconds)) {
    return '0:00';
  }
  var _secondsToTime = secondsToTime(seconds),
    hours = _secondsToTime.hours,
    minutes = _secondsToTime.minutes,
    remainingSeconds = _secondsToTime.seconds;
  var prettyHoursWithSeparator = hours > 0 ? hours + ':' : '';
  var prettyMinutes = prettyHoursWithSeparator ? pad(minutes) : minutes;
  return "".concat(prettyHoursWithSeparator).concat(prettyMinutes, ":").concat(pad(remainingSeconds));
};